import React, { FC } from "react";
import { ZaraTalent } from "../../assets/images";
import { BestMatchBadge, Experience, OpenFor, Pin } from "../../assets/icons";

import "./OurTalent.scss";

interface Props {
  talent: {
    id: string;
    location: {
      city: string;
      country: string;
      id: number;
      state: string;
      talent: string;
    };
    experience: number;
    name: string;
    profession: string;
    image: string;
    schedule: string[];
  };
}

const OurTalent: FC<Props> = ({ talent }: Props) => {
  return (
    <div className="ourTalent">
      <div className="ourTalent__profile">
        <img src={talent.image} alt="" width={72} height={72} />
        <div className="content">
          <div>{talent.name}</div>
          <span>{talent.profession}</span>
        </div>
      </div>
      <div className="ourTalent__details">
        <div>
          <span>
            <Pin /> From
          </span>
          {talent.location?.city}, {talent.location?.state}
        </div>
        <div>
          <span>
            <Experience />
            Experience
          </span>
          {Math.floor(talent.experience) > 0 && (
            <span>
              {Math.floor(talent.experience)} year
              {Math.floor(talent.experience) !== 1 && "s"}
            </span>
          )}
        </div>
        <div>
          <span>
            <OpenFor />
            Open for
          </span>
          {talent.schedule.length > 0
            ? `${talent.schedule.join(" • ")} ${
                talent.schedule.length > 1 ? "Roles" : "Role"
              }`
            : ""}
        </div>
      </div>
      <div className="buttons">
        <button
          onClick={() =>
            window.open(
              `${process.env.REACT_APP_MAIN_URL}/profile/talent/${talent.id}`,
              "_blank"
            )
          }
        >
          View Profile
        </button>
      </div>
    </div>
  );
};

export default OurTalent;